export type MDSAliases = 's' | 'm' | 'l' | 'xl';

type Matcher = (url: string) => boolean;
type Converter = (url: string, alias: MDSAliases) => string;

interface Namespace {
    matcher: Matcher;
    converter: Converter;
}

type Config = Record<string, Namespace>;

type MDSPicMap = Record<MDSAliases, string>;

export const sizeAliasRegex =
    /\/orig(_[\w_]+)?$|\/\d+x\d+(_[\w_]+)?$|\/(?:optimize|grid(?:_\d+x)?|card(?:_\d+x)?|small_card(?:_\d+x)?|small|big|hugeX?|huge)(_[\w_]+)?$/;

export const config: Config = {
    Inspire: {
        matcher: matchKey('inspire'),
        converter: replaceSizeAlias({
            s: 'small_card',
            m: 'small_card_2x',
            l: 'card',
            xl: 'card_2x',
        }),
    },
    YabsPerformance: {
        matcher: matchKey('yabs_performance'),
        converter: replaceSizeAlias({
            s: 'small',
            m: 'big',
            l: 'huge',
            xl: 'hugeX',
        }),
    },
    GoodsPic: {
        matcher: matchKey('goods_pic'),
        converter: replaceSizeAlias({
            s: '150x150',
            m: '250x250',
            l: '500x500',
            xl: '600x600',
        }),
    },
    Vh: {
        matcher: matchKey('vh'),
        converter: replaceSizeAlias({
            s: 'scale_360',
            m: 'scale_360',
            l: 'scale_1200',
            xl: 'scale_1200',
        }),
    },
};

export function matchKey(key: string): Matcher {
    return (url: string) => url.includes(`/get-${key}/`);
}

export function matchHost(key: string): Matcher {
    return (url: string) => url.startsWith(`//${key}`);
}

function replaceSizeAlias(aliasMap: MDSPicMap): Converter {
    return (url: string, alias: MDSAliases): string =>
        url.replace(
            sizeAliasRegex,
            (_match, origSuffix, aliasSuffix) =>
                '/' + aliasMap[alias] + (origSuffix ?? '') + (aliasSuffix ?? ''),
        );
}

export function getMdsNamespace(url: string): Namespace | undefined {
    for (const name in config) {
        const namespace = config[name];
        if (namespace.matcher(url)) {
            return namespace;
        }
    }
}

/** Подставляет алиас в соответствии с неймспейсом */
export function getMdsUrl(url: string, alias: MDSAliases): string {
    const namespace = getMdsNamespace(url);

    if (!namespace) {
        return url;
    }

    return namespace.converter(url, alias);
}
